"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("@mui/material/utils");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports["default"] = (0, _utils.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: 'M4 4L4 20H2L2 4L4 4ZM22 4V20H20V4L22 4ZM15 13V16L19 12L15 8L15 11H9V8L5 12L9 16L9 13L15 13Z'
}), 'AutofitWidthIcon');